module.exports = __webpack_public_path__ + "static/media/Bluelab Soil pH Pen.0b0b6287.webp";